module.exports = __webpack_public_path__ + "img/image11.e7aeef91.jpeg";